import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App, { preloadInitialRoute } from "@/App";
import { initAnalytics } from "@/lib/analytics";
import { applyStoredConsent } from "@/lib/consent";
import { initGA } from "@/utils/ga";
import { runWhenIdle } from "@/lib/idle";

// Analytics scripts are heavy and not needed for the first paint: they start on the first interaction or a few
// seconds after load. Events fired before that are queued (see lib/analytics and utils/ga).
runWhenIdle(() => {
  initAnalytics();
  initGA();
});
applyStoredConsent();

const root = ReactDOM.createRoot(document.getElementById("root"));
// Load the chunk for the page being opened first, so server-rendered HTML is not blanked while it downloads.
preloadInitialRoute().then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
